export default {
    init() {
        // JavaScript to be fired on the home page
        // Set up variables
        var $featuredContentItems = $('.featured-content-item');
        var $featuredContentItemImages = $('.featured-content-item-image');

        // If there are recent posts, set the first recent post image to the container bg image
        if ($featuredContentItems) {
            $featuredContentItems.on('mouseenter', function () {
                var $itemData = $(this).data('item');

                $featuredContentItems.removeClass(
                    'featured-content-item--active'
                );
                $(this).addClass('featured-content-item--active');

                $featuredContentItemImages.removeClass(
                    'featured-content-item-image--active'
                );

                $featuredContentItemImages.each(function () {
                    if ($(this).data('item') == $itemData) {
                        $(this).addClass('featured-content-item-image--active');
                    }
                });
            });
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js